<template>
  <div class="opinionuser">
    <div v-if="mode === 'notcomment'">
    <div class="box-notcomment">
    <div class="imgs-opinionuser-empty">
        <v-icon>search_off</v-icon>
      </div>
      <div class="texts-opinionuser-empty">
        <span>کاربری نظر ثبت نکرده است</span>
      </div>
    </div>
    </div>
    <div v-else-if="mode === 'create'">
      <v-container>
        <div class="content-opinionuser">
          <div class="title-content-opinionuser">
            <div class="title-content-opinionuser-r">
              <div class="img-title-content">
                <img src="../../assets/image/background_intro.png" alt="" />
              </div>
              <div class="text-title-opinionuser">
                <h6>mahsa</h6>
                <span>1399-06-06</span>
              </div>
            </div>
            <div class="rate-user">
              <v-rating
                v-model="rating"
                background-color="#8f14c4"
                color="#8f14c4"
                large
              ></v-rating>
            </div>
          </div>
          <div class="text-content-opinionuser">
            <span
              >لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با
              استفاده از طراحان گرافیک است.</span
            >
            <span
              >لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با
              استفاده از طراحان گرافیک است.</span
            >
            <span
              >لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با
              استفاده از طراحان گرافیک است.</span
            >
          </div>
          <div class="footers-content-opinionuser">
          <div class="img-footers-content">
          <img src="../../assets/image/welcome_emoji.jpg" alt="" />
          </div>
          <div class="rate-footer-opinionuser">
          <span>1 +</span>
          <v-icon>
          favorite_border
          </v-icon>
          </div>
          </div>
        </div>
  
    
      </v-container>
    </div>
  </div>
</template>
<script>
export default {
  name: "opinionuser",
  data: () => ({
    rating: 5,
    mode: "notcomment",
  }),
};
</script>
<style>
.opinionuser {
  background-image: url("../../assets/image/background.jpg");
  height: 100%;
  position: relative;
  background-size: cover;
  padding: 0;
  z-index: 10;
  overflow: auto;
  display: flex;
  justify-content: center;
}

.content-opinionuser {
  margin-top: 20px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 5px;
}
.content-opinionuser:first-child {
  margin-top: 4em;
}
.img-title-content {
  width: 50px;
  height: 50px;
  border-radius: 50px;
  overflow: hidden;
}
.img-title-content img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.text-title-opinionuser {
  display: flex;
  flex-direction: column;
  padding: 10px;
}
.text-title-opinionuser h6 {
  font-size: 13px;
}
.text-title-opinionuser span {
  font-size: 13px;
  color: #707070;
}
.title-content-opinionuser-r {
  display: flex;
  padding: 10px;
}
.rate-user .v-rating button {
  font-size: 15px !important;
  padding: 0;
}
.title-content-opinionuser {
  display: flex;
  justify-content: space-between;
}
.rate-user {
  padding: 20px;
}
.text-content-opinionuser span {
  font-size: 12px;
  line-height: 2;
}
.text-content-opinionuser {
  padding: 10px 15px;
}

.imgs-opinionuser-empty .v-icon {
  font-size: 70px;
  color: #0000cd;
  display: flex;
}
.texts-opinionuser-empty{
  font-size: 15px;
  color: #0000cd;
}
.box-notcomment{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
}
.img-footers-content{
  width: 100%;
  height: 150px;
}
.img-footers-content img{
  width: 100%;
  height: 100%;
}
.rate-footer-opinionuser ,
.rate-footer-opinionuser .v-icon{
  color: #50ac17;
  font-size: 20px;
  display: flex;
  justify-content: flex-end;
  padding: 5px 10px;
  align-items: center;
}
.rate-footer-opinionuser span{
  font-size: 15px;
}
</style>
